"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEvent = exports.useSubscription = void 0;
var react_1 = require("react");
/**
 * React Hook to subscribe to an specific event.
 *
 * @param {Event} event - The event to subscribe. The Event is considered constant across renders.
 * @param {Function} callback -  A function to be called when the subscription gets triggered.
 * @param {any[]} deps -  List of dependencies for the callback. Follow the same rules of useEffect.
 */
function useSubscription(event, callback, deps) {
    if (deps === void 0) { deps = undefined; }
    var callbackRef = react_1.useRef(callback);
    callbackRef.current = callback;
    if (deps) {
        console.warn("Deps param has been deprecated, it is not useful anymore.");
    }
    react_1.useEffect(function () {
        var subscriptionCallback = function (eventData) {
            callbackRef.current(eventData);
        };
        var subscription = event.subscribe(subscriptionCallback);
        return function () {
            subscription.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event]);
}
exports.useSubscription = useSubscription;
/**
 * React Hook to subscribe to an Event.
 *
 * @param {Event} event - The event.
 * @param {object}  params - Params.
 * @param {object}  params.initialValue - Initial Value.
 * @param {object}  params.reducer - Reducer for transform the data.
 * @returns {object} Data object.
 */
function useEvent(event, params) {
    var _a = react_1.useState(params && params.initialValue !== undefined
        ? params.initialValue
        : event.get()), value = _a[0], setValue = _a[1];
    react_1.useEffect(function () {
        var handleStateChange = function (state) {
            var eventState = (params === null || params === void 0 ? void 0 : params.reducer) ? params.reducer(state) : state;
            setValue(eventState);
        };
        var subscription = event.subscribe(handleStateChange);
        return function () {
            subscription.unsubscribe();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [event, params === null || params === void 0 ? void 0 : params.reducer]);
    return value;
}
exports.useEvent = useEvent;
